/* eslint-disable camelcase */
// ApckDraggableTable.vue bundles a stale core-js v2 that sets globals
// remove them so scanners see our actual core-js v3.49.0 instead.
// (function() {
//   if (typeof window !== 'undefined') {
//     if (window.core && window.core.version && window.core.version.charAt(0) === '2') delete window.core;
//     if (window['__core-js_shared__']) delete window['__core-js_shared__'];
//   }
// })();

// eslint-disable-next-line import/extensions
import Vue from 'vue';
import '../scss/_bootstrap-utilities.scss';
import VueRouter from 'vue-router';

import PortalVue from 'portal-vue';

import setConfigs from '@gitlab/ui/dist/config';

import VueApexCharts from 'vue-apexcharts';
import ApckFlash from './plugins/flash';
import ApckLightbox from './plugins/lightbox';

// eslint-disable-next-line import/named
import { getRouter } from './routes/detections';
import { GlobalSPAComponents, RegisterGlobalComponents, RegisterUIComponents } from './globals';
import DataCmpPlugin from './plugins/data-cmp-names';

Vue.use(VueRouter);
Vue.use(PortalVue);
setConfigs();
Vue.use(ApckFlash);
Vue.use(ApckLightbox);
Vue.use(VueApexCharts);
Vue.use(DataCmpPlugin);

export const Vue_entry = Vue;

RegisterGlobalComponents(GlobalSPAComponents, Vue);
RegisterUIComponents(Vue);

const App = () => {
  const sidebar = true;
  Vue.config.productionTip = false;
  Vue.config.devtools = false;
  Vue.config.productionSourceMap = false;
  return new Vue({
    el: '#vue-main',
    router: getRouter({ sidebar }),
  });
};
App();
